import { Injectable, Signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AdsService {
    constructor() { }

    // method to always return N ads with fallback
    getDisplayedAds(adsFromApi:any[], maxCount: number = 3) {
        const ads = adsFromApi.slice(0, maxCount);
        const defaultAdsCount = maxCount - ads.length;
        const defaultAds = Array.from({ length: defaultAdsCount }).map(() => ({
            isDefault: true,
        }));
        return [...ads, ...defaultAds];
    }
}
